import { Layer, ThemeContext } from 'grommet';

interface WelcomeModalProps {
  onStart: () => void;
  mascotSrc: string;
  mapSrc: string;
}

const layerTheme = {
  layer: {
    background: 'var(--primaryGreen)',
    border: { radius: '16px' },
    container: { extend: 'overflow: hidden;' },
  },
};

const WelcomeModal = ({ onStart, mascotSrc, mapSrc }: WelcomeModalProps) => {
  return (
    <ThemeContext.Extend value={layerTheme}>
      <Layer animation="fadeIn" responsive={false}>
        <div className="preflight relative w-[1036px]">
          <div className="preflight grid h-[320px] overflow-hidden">
            <img
              src={mapSrc}
              alt=""
              className="preflight pointer-events-none col-start-1 row-start-1 h-full w-full object-cover"
            />

            <div className="preflight col-start-1 row-start-1 flex flex-col items-center pt-[39px]">
              <h2 className="preflight preflight-h2 max-w-[1007px] text-center text-[35px] font-bold leading-[28px] text-white">
                Welcome to Your All-Access Guided Tour!
              </h2>
              <p className="preflight preflight-p mt-5 max-w-[804px] text-center text-lg font-medium leading-normal text-white">
                You set the pace! Go back, skip ahead, or take a break and chill with any animal you like.
              </p>
            </div>
          </div>

          <div className="preflight relative h-[208px] bg-[#FFDF6C]">
            <div className="preflight pointer-events-none absolute left-0 top-[-112px] h-[320px] w-[323px] overflow-hidden">
              <img src={mascotSrc} alt="Zoolife mascot" className="preflight h-full w-full object-contain" />
            </div>

            <div className="preflight absolute left-[326px] top-[27px] flex h-[101px] w-[631px] items-center rounded-[10px] bg-white px-4">
              <div className="preflight absolute left-[-11px] top-[33px] h-0 w-0 border-y-[10px] border-r-[13px] border-y-transparent border-r-white" />
              <p className="preflight preflight-p text-lg font-bold leading-[1.3] text-[#1c1917]">
                Follow me on our virtual visit to a few of the world&rsquo;s top zoos today, as I share my favourite stories,
                special moments, and insider facts! Ready?
              </p>
            </div>

            <button
              type="button"
              onClick={onStart}
              className="preflight preflight-button absolute left-[326px] top-[142px] flex h-8 items-center justify-center whitespace-nowrap rounded-full bg-primary-green px-4 py-2 text-base font-bold leading-none text-white"
            >
              Let&rsquo;s Step Into Nature
            </button>
          </div>
        </div>
      </Layer>
    </ThemeContext.Extend>
  );
};

export default WelcomeModal;
